// extracted by mini-css-extract-plugin
export var dividerLine = "_5h-0";
export var errorBackground = "_5h-1";